/*
*
* Buildpath - Misc Custom Javascript + Liquid Theme Modifications
*
*/

console.log('Buildpath Custom js Loaded');

// Sticky add to cart bar on product pages
setTimeout(function() {
   
    var qtyInputSticky = document.querySelector('.sticky-atc-bar .quantity__input');
    var qtyInputFormElement = document.querySelector('.product-form__quantity quantity-input .quantity__input');
    
    var plusButton = document.querySelector('.sticky-atc-bar .quantity .qty-plus');
    var minusButton = document.querySelector('.sticky-atc-bar .quantity .qty-minus');

    plusButton.addEventListener('click', function() {
        setTimeout(function() {
            console.log('Plus button clicked');
            qtyInputFormElement.value = qtyInputSticky.value;
            console.log('qtyInputFormElement updated:', qtyInputFormElement.value);
        }, 0);
    });
    
    minusButton.addEventListener('click', function() {
        setTimeout(function() {
            console.log('Minus button clicked');
            qtyInputFormElement.value = qtyInputSticky.value;
            console.log('qtyInputFormElement updated:', qtyInputFormElement.value);
        }, 0);
    });
    

    // //make ATC button work with existing theme atc js in theme.liquid
    // atcButtonSticky.addEventListener('click', function(e) {
    //     var variantId = this.getAttribute('data-variant-id');
    //     var productId = this.getAttribute('data-product-id');
    //     addItemToCart(variantId, productId);
    // });
    
    
    
    
    
    var atcButtonSticky = document.querySelector('.sticky-atc-bar .product-form__submit');
    console.log('atcButtonSticky:', atcButtonSticky); // log the atcButtonSticky element
    
    atcButtonSticky.addEventListener('click', function(e) {
        e.preventDefault();  
        console.log('atcButtonSticky clicked'); // log a message when atcButtonSticky is clicked
        buttonElement = atcButtonSticky;
        if (buttonElement.classList.contains('loading')) return;
        
        const originalButtonText = buttonElement.innerText;
    
        // Disable the button
        buttonElement.setAttribute('aria-disabled', true);
        buttonElement.classList.add('loading');
    
        // Update text for the button
        buttonElement.innerText = "Adding to cart...";
    
    
        // Trigger a change event on the qtyInputFormElement to ensure the updated value is picked up
        var event = new Event('change');
        qtyInputFormElement.dispatchEvent(event);
    
        var productForm = document.querySelector('[data-type="add-to-cart-form"]');

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(productForm).serialize(),
            dataType: 'json',
            success: function () {
                console.log('Product added successfully');
                $('.cart-notification').html('Product added successfully');
    
                setTimeout(function () {
                    $.getJSON('/cart.js', function (cart) {
                        console.log('Cart updated. Items: ', cart.item_count);
                        var result = cart.item_count;
                        $('.cart-counter').html(result);
                    });
                }, 1000);
    
                // Once the product is added to the cart, update button's text
                buttonElement.innerHTML = "Added to cart &#10004;";
            
                // Restore button's original text after 3 seconds
                setTimeout(() => {
                    buttonElement.innerText = originalButtonText;
                    buttonElement.blur();
                }, 3000);
                
                // Finally, restore the button to its original state
                buttonElement.classList.remove('loading');
                buttonElement.removeAttribute('aria-disabled');
            },
            error: function () {
                console.log('Error adding product');
            }
        });
    });
    
}, 2000);


/* Show sticky ATC bar after product form scrolled out of view */
// window.addEventListener("load", function() {
//     var stickyBar = document.querySelector('.sticky-atc-bar-wrapper');
//     var triggerDiv = document.querySelector('.product-form__buttons');
//     var triggerDivTopOffset = 50;

//     window.addEventListener('scroll', function() {
//         var triggerDivTopPosition = triggerDiv.getBoundingClientRect().top;
        
//         if (triggerDivTopPosition <= triggerDivTopOffset) {
//             stickyBar.classList.add('show');
//         } else {
//             stickyBar.classList.remove('show');
//         }
//     });
// });


window.addEventListener("load", function() {
    var stickyBar = document.querySelector('.sticky-atc-bar-wrapper');
    var triggerDiv = document.querySelector('.product-form__buttons');
    var triggerDivTopOffset = 50;

    window.addEventListener('scroll', function() {
        // Check if it's a mobile viewport
        var isMobile = window.innerWidth <= 991;
        
        if (isMobile) {
            // For mobile: show the sticky bar if user scrolls more than a few pixels
            if (window.scrollY > 10) {
                stickyBar.classList.add('show');
            } else {
                stickyBar.classList.remove('show');
            }
        } else {
            // For desktop: existing behavior based on product-form__buttons position
            var triggerDivTopPosition = triggerDiv.getBoundingClientRect().top;

            if (triggerDivTopPosition <= triggerDivTopOffset) {
                stickyBar.classList.add('show');
            } else {
                stickyBar.classList.remove('show');
            }
        }
    });
});

